import React, { useState } from "react";
import CustomAlert from "../../../Components/CustomAlert";

let setNotification: React.Dispatch<React.SetStateAction<Notification | null>>;

interface Notification {
  message: string;
  type: "success" | "error" | "info" | "warning"
}

export const NotificationContainer = () => {
  const [notification, _setNotification] = useState<Notification | null>(null);

  setNotification = _setNotification;
  return notification ? <CustomAlert message={notification.message} type={notification.type} /> : null;
};

export const useNotify = () => {
  return (message: string, type: "success" | "error" | "info" | "warning") => {
    if (setNotification) {
      setNotification({ message, type });
      setTimeout(() => setNotification(null), 3000);
    } else {
      console.warn("NotificationContainer is not mounted!");
    }
  };
};
